import Vue from 'vue'
import Vuex from 'vuex'
import Constant from "@/constant";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        // Toolbar Posison
        // toolbarActivePosition: "main",
        // 아래 toolbar의 위치
        toolbarActivePosition: Constant.MAIN_TAB.HOME,
        noticeData: {},
        // 우에 놓이는 두번째 tabbar의 위치
        topTabBarPosition: Constant.LISTEN_TEACHER_TAB.MISSION,
        routerZIndex:'auto',
        // 기본플레이어 활성화 여부
        basicPlayerVisibility: false,
        memberInfo: {},
        enableHamburgerMenu: false,
        showAttendanceRewardPopup: true,
        doNotShowMissionPopupToday: false,
        doNotShowNoticePopupToday: false,
        seasonType: "",
        seasonExpireTime: 0,
        seasonPoints: 0,
        showMissionPopup: false,
        showNoticePopup: true,
        miniPlayerBottom: '90px',
        chatQuestionPosition: Constant.LISTEN_TALK_TAB.CHAT,
        loadChallengeTemp: false,
        communityTabIndex: 1,
        isBoardDetail: false,
        boardId: -1,
        purchaseTabIndex: null,
        push: {},
        param: {},
        loading: false,
        headerTooltipType: Constant.HEADER_TOOLTIP_TYPE.POINT,
        headerMainTitle: '',
        headerSecondaryTitle: '',
        headerIsShowBack: true,
        headerIsShowMenu: true,
        headerIsShowOnlineStatus: true,
        headerProfile: '',
        subRouterView: {},
        isShowHeaderBar: true,
        onlineStatus: Constant.USER_ONLINE_STATUS.ONLINE,
        playerMode: 'basic',
        myMadeTextbookCnt: 0,
        playlistPutIDs: [],
        modal:{
            name:'',
            visible:false,
            data:{},
        }
    },
    getters: {
        getPlayerMode: state => state.playerMode,
        getTopTabBarPosition: state => state.topTabBarPosition,
        getChatQuestionPosition: state => state.chatQuestionPosition,
        getLoadChallengeTemp: state => state.loadChallengeTemp,
        getCommunityTabIndex: state => state.communityTabIndex,
        getPurchaseTabIndex: state => state.purchaseTabIndex,
        getIsBoardDetail: state => state.isBoardDetail,
        getIsShowHeaderBar: state => state.isShowHeaderBar,
        getBoardId: state => state.boardId,
        getPush: state => state.push,
        getParam: state => state.param,
        isLoading: state => state.loading,
    },
    mutations: {
        setTopTabBarPosition: (state, pos) => state.topTabBarPosition = pos,
        setChatQuestionPosition: (state, pos) => state.chatQuestionPosition = pos,
        setLoadChallengeTemp: (state, pos) => state.loadChallengeTemp = pos,
        setCommunityTabIndex: (state, pos) => state.communityTabIndex = pos,
        setIsBoardDetail: (state, pos) => state.isBoardDetail = pos,
        setBoardId: (state, pos) => state.boardId = pos,
        setPurchaseTabIndex: (state, idx) => state.purchaseTabIndex = idx,
        setPush: (state, pos) => state.push = pos,
        setParam: (state, pos) => state.param = pos,
        setLoading: (state, loading) => state.loading = loading,
        setPlayerMode: (state, val) => state.playerMode = val,
    },
    actions: {

    },
});
